/**
 * @type {{
  API_URL: String,
  BEARER_DOMAINS: Array.<String>,
  BILLING_URL: String,
  COLLECTOR_COOKIE_DOMAIN: String,
  COLLECTOR_HOST: String,
  HELP_URL: String,
  WWW_URL: String,
  VC_WWW_URL: String,
  VC_INFO_URL: String,
  HELP_URL: String,
  APP_URL: String,
  ENABLED_FEATURES: Array.<String>,
  }}
 */
const config = window.SRCCLR_ENV;
export default config;
